export default "__VITE_ASSET__CtXMluVV__"